import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingScreenComponent } from './setting-screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    SettingScreenComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    CustomInputModule
],
  exports:[
    SettingScreenComponent
  ]
})
export class SettingScreenModule { }
